import { Button } from '@/shared/components/shadcn/button';
import { useLoading } from 'react-simplikit';

interface NewSessionAlertProps {
  isOpen: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  message: string;
}

export function NewSessionAlert({ isOpen, onConfirm, onCancel, message }: NewSessionAlertProps) {
  const [isLoading, startLoading] = useLoading();

  const handleConfirm = async () => {
    await startLoading(onConfirm());
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-background border-border mx-4 w-full max-w-md rounded-lg border p-6 shadow-lg">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <h3 className="text-foreground mb-2 text-lg font-semibold">Start a new chat</h3>
            <p className="text-muted-foreground mb-4 text-sm">{message}</p>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={onCancel} disabled={isLoading}>
                Cancel
              </Button>
              <Button onClick={handleConfirm} disabled={isLoading}>
                {isLoading ? 'Starting...' : 'Start New'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
